import yup from "yup";
import { pick } from "@bonliva-crm/common";
import { regexps } from "@bonliva-crm/common";
import locale from "@bonliva-crm/locale";
import { ContactPersonEditorFragment, ContactPersonInput, CustomerType } from "@graphql";
import { Option } from "@components/Select";

export type FormData = {
  IsInheritable: boolean;
  AreasOfExpertise: string[];
  BooksProfessions: string[];
  Customers: Option[];
  CustomerGroups: string[];
  Email: string;
  IsOrgLevel: boolean;
  Name: string;
  Phone: string;
  CellPhone: string;
  Roles: string[];
  Title: string;
};

export const initialValues: FormData = {
  IsInheritable: false,
  AreasOfExpertise: [],
  BooksProfessions: [],
  Customers: [],
  CustomerGroups: [],
  Email: "",
  IsOrgLevel: false,
  Name: "",
  Phone: "",
  CellPhone: "",
  Roles: [],
  Title: ""
};

export type FormParams = {
  allowedAreasOfExpertise: string[];
  customerLookupType: CustomerType;
};

export const validationSchema = yup.object<FormData>({
  IsInheritable: yup.boolean(),
  AreasOfExpertise: yup.array(yup.string()).nullable(true),
  BooksProfessions: yup.array(yup.string()).nullable(true),
  Customers: yup.array().min(1, locale.FillSomething(locale.Customers)),
  CustomerGroups: yup.array(yup.string()).nullable(true),
  Email: yup.string().email(locale.SelectSomething(locale.Email)),
  IsOrgLevel: yup.boolean(),
  Name: yup.string().required(locale.Name),
  Title: yup.string().required(locale.TitleIsMissing),
  Roles: yup.array(yup.string()).nullable(true),
  Phone: yup.string().matches(regexps.phoneNumber, locale.PhoneNumberMissing),
  CellPhone: yup.string().matches(regexps.phoneNumber, locale.CellPhoneNumberMissing)
});

export function mapDataToForm(data: ContactPersonEditorFragment): FormData {
  return {
    ...initialValues,
    ...pickCommon(data),
    IsOrgLevel: false,
    Customers: data.CustomerRefs.map((c) => ({
      label: c.Name,
      value: c.Id
    }))
  };
}

export function formDataToInput(data: FormData): ContactPersonInput {
  return {
    ...pickCommon(data),
    CustomersIds: data.Customers.map((x) => x.value)
  };
}

const pickCommon = (data: FormData | ContactPersonEditorFragment) =>
  pick(
    data,
    "IsInheritable",
    "AreasOfExpertise",
    "BooksProfessions",
    "CustomerGroups",
    "Email",
    "Name",
    "Phone",
    "CellPhone",
    "Roles",
    "Title"
  );
